module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/original_category_link-b7b1c0507dee1db9e15bc35618db76c7.png";